"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const petitionNotificationSelectedUsersIds = (0, graphql_tag_1.default)`
  query petitions_petition_notify_selectedUsersIds(
    $petitionId: Int!
    $search: String
    $filters: [FilterCoreInput]
    $selection: SelectionInput
    $sort: NotifyBaseSortInput
    $selectedUsersIdList: [Int]
  ) {
    petitions {
      petition {
        notify {
          selectedUsersIds(
            petitionId: $petitionId
            search: $search
            filters: $filters
            selection: $selection
            sort: $sort
            selectedUsersIdList: $selectedUsersIdList
          )
        }
      }
    }
  }
`;
exports.default = petitionNotificationSelectedUsersIds;